var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlympicRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 40,
    viewBox: "0 0 86 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_1187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 12,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5112 12.7516H71.3076V39.6119H44.5112V12.7516Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0917 26.8713C68.7374 32.7309 63.874 37.3718 57.9342 37.3718C51.7537 37.3718 46.7515 32.3628 46.7515 26.1808C46.7515 21.2156 49.9789 17.0058 54.4518 15.5413C54.5335 14.9965 54.5755 14.439 54.5755 13.8705C54.5755 13.6373 54.5671 13.4082 54.5562 13.18C48.7771 14.679 44.5112 19.9313 44.5112 26.1808C44.5112 33.5966 50.5175 39.6118 57.9342 39.6118C64.9815 39.6118 70.7639 34.1684 71.3076 27.2503C70.5493 27.1846 69.8087 27.0574 69.0917 26.8713ZM57.9347 14.9891C63.5388 14.9891 68.1859 19.1214 68.9929 24.5119C69.7302 24.751 70.501 24.9178 71.2988 25.0028C70.7014 18.137 64.9442 12.7516 57.9347 12.7516C57.5418 12.7516 57.1547 12.7692 56.7743 12.8012C56.7986 13.1541 56.8138 13.5103 56.8138 13.8707C56.8138 14.2682 56.7936 14.6624 56.7633 15.0498C57.147 15.0093 57.5367 14.9891 57.9347 14.9891Z",
    fill: "#00A651"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_202_1187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 12,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4319 12.7521H42.2308V39.6121H15.4319V12.7521Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_202_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2308 27.2499C41.6871 34.1688 35.9073 39.6123 28.8549 39.6123C21.4398 39.6123 15.4319 33.597 15.4319 26.1804C15.4319 19.9318 19.6987 14.6794 25.4786 13.1805C25.4887 13.4078 25.4962 13.6377 25.4962 13.8701C25.4962 14.4395 25.4533 14.9969 25.3725 15.5418C20.9004 17.0062 17.6738 21.2161 17.6738 26.1804C17.6738 32.3624 22.6745 37.3723 28.8549 37.3723C34.7972 37.3723 39.6606 32.7313 40.015 26.8718C40.7294 27.0571 41.4734 27.185 42.2308 27.2499ZM27.684 15.0502C27.716 14.6629 27.7362 14.2687 27.7362 13.8704C27.7362 13.5108 27.721 13.1546 27.6966 12.8017C28.077 12.7697 28.4641 12.7521 28.8555 12.7521C35.8658 12.7521 41.6296 18.1375 42.2271 25.0033C41.4242 24.9174 40.6509 24.7515 39.9154 24.5124C39.1083 19.1219 34.4603 14.9888 28.8555 14.9888C28.459 14.9888 28.0678 15.0098 27.684 15.0502Z",
    fill: "#FCB131"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_202_1187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 0,
    width: 27,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0876 0.440674H85.8908V27.301H59.0876V0.440674Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_202_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8908 13.8709C85.8908 21.2884 79.8836 27.3011 72.4694 27.3011C65.4516 27.3011 59.6962 21.9166 59.0986 15.0499C59.9015 15.1332 60.6698 15.3017 61.4096 15.5417C62.2141 20.9304 66.8578 25.0636 72.4694 25.0636C78.6449 25.0636 83.6522 20.0512 83.6522 13.8709C83.6522 7.69138 78.6449 2.67905 72.4694 2.67905C66.5221 2.67905 61.662 7.32085 61.3078 13.1812C60.5882 12.9959 59.851 12.868 59.0876 12.8014C59.6372 5.88334 65.4163 0.440674 72.4694 0.440674C79.8836 0.440674 85.8908 6.45431 85.8908 13.8709Z",
    fill: "#EE334E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_202_1187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 27,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0122 0.440674H56.8127V27.301H30.0122V0.440674Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_202_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3892 25.0638C37.7836 25.0638 33.1356 20.9306 32.3293 15.5419C31.5913 15.3019 30.8221 15.1334 30.0193 15.0501C30.6176 21.9168 36.3731 27.3014 43.3892 27.3014C43.7831 27.3014 44.1711 27.2854 44.5531 27.2509C44.5271 26.9005 44.511 26.5427 44.511 26.1813C44.511 25.7847 44.5313 25.3906 44.5641 25.0041C44.1778 25.0437 43.7864 25.0638 43.3892 25.0638ZM43.3889 0.440674C36.3366 0.440674 30.5584 5.88334 30.0122 12.8014C30.7721 12.868 31.5077 12.996 32.2297 13.1812C32.5815 7.32085 37.4449 2.67905 43.3889 2.67905C49.5693 2.67905 54.575 7.69138 54.575 13.8709C54.575 18.8353 51.3459 23.0467 46.8722 24.5129C46.7922 25.0552 46.7509 25.6135 46.7509 26.1811C46.7509 26.4144 46.7526 26.6451 46.7687 26.8717C52.5468 25.3735 56.8127 20.1212 56.8127 13.8709C56.8127 6.45431 50.8056 0.440674 43.3889 0.440674Z",
    fill: "#494949"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_202_1187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.892822 0.440674H27.7341V27.301H0.892822V0.440674Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_202_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7336 13.8709C27.7336 6.45431 21.7265 0.440674 14.3106 0.440674C6.90148 0.440674 0.891846 6.45431 0.891846 13.8709C0.891846 21.2884 6.90148 27.3011 14.3106 27.3011C14.7036 27.3011 15.0882 27.2852 15.472 27.2515C15.4459 26.9003 15.4299 26.5424 15.4299 26.1811C15.4299 25.7845 15.4509 25.3903 15.4821 25.0038C15.0967 25.0434 14.707 25.0636 14.3106 25.0636C8.13437 25.0636 3.12705 20.0512 3.12705 13.8709C3.12705 7.69138 8.13437 2.67905 14.3106 2.67905C20.4902 2.67905 25.4942 7.69138 25.4942 13.8709C25.4942 18.8361 22.2651 23.0467 17.7922 24.5129C17.7131 25.0552 17.6719 25.6135 17.6719 26.1811C17.6719 26.4144 17.6735 26.6451 17.6887 26.8717C23.4677 25.3735 27.7336 20.1212 27.7336 13.8709Z",
    fill: "#0081C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympicRings);
export default __webpack_public_path__ + "static/media/olympic-rings.4921e97a5bc89586f88ca1e241e93d33.svg";
export { ForwardRef as ReactComponent };